import React, { useContext } from 'react';
// Libs & contexts
import {
	BriefingContext,
    ObjectivesContants,
    ObjectivesContantsNames,
} from '../../../../containers/campanhas/Briefing';
// Styles
import { BriefingTitleRow } from '../index';
// Components
import CampaignObjectiveRadio from '../../CampaignObjectiveRadio';

// Others
import { ReactComponent as Car } from '../../../../img/campanhas/car.svg';
import { ReactComponent as Garage } from '../../../../img/campanhas/garage.svg';

const BriefingStep1 = () => {
    const {
        campaign,
    } = useContext(BriefingContext);

    return (
	<>
		<BriefingTitleRow>Selecione uma das duas opções:</BriefingTitleRow>
		<div className="row mb-1" style={{ minHeight: '284px' }}>
			<div className="col-6">
				<CampaignObjectiveRadio
					actualObjective={campaign.campaignObjective}
					objectiveId={ObjectivesContants.RAPIDEZ}
					setObjective={campaign.setCampaingObjective}
					logo={Car}
					title="Quero divulgar os anúncios do meu estoque"
					label={ObjectivesContantsNames[0]}
					id="campagin-objective-performance"
				/>
			</div>
			<div className="col-6">
				<CampaignObjectiveRadio
					actualObjective={campaign.campaignObjective}
					objectiveId={ObjectivesContants.SEGURANCA}
					setObjective={campaign.setCampaingObjective}
					logo={Garage}
					title="Quero divulgar minha loja"
					label={ObjectivesContantsNames[1]}
					id="campagin-objective-visibility"
				/>
			</div>
		</div>
	</>
    );
};

export default BriefingStep1;
